import {HttpWrapper} from "./HttpWrapper";

const httpWrapper = new HttpWrapper(process.env.VUE_APP_NEW_PUBLIC_API_URL);

export function trackParcel(trackCode) {
    return httpWrapper.get("/parcel/track", {track_code: trackCode});
}
